/** Sport slugs for Match Hub routing and session storage. */
export const MATCH_HUB_SPORTS = Object.freeze([
  "football",
  "basketball",
  "rugby",
  "tennis",
  "volleyball",
]);

export const DEFAULT_MATCH_SPORT = "football";

/** Vue Router route names for sport-specific team registration. */
export const SPORT_REGISTRATION_ROUTES = Object.freeze({
  football: "FootballTeamRegistration",
  basketball: "BasketballTeamRegistration",
  rugby: "RugbyTeamRegistration",
  tennis: "TennisTeamRegistration",
  volleyball: "VolleyballTeamRegistration",
});

/** Vue Router route names for sport-specific team owner dashboards. */
export const SPORT_DASHBOARD_ROUTES = Object.freeze({
  football: "TeamDashboard",
  basketball: "BasketballTeamDashboard",
  rugby: "RugbyTeamDashboard",
  tennis: "TennisTeamDashboard",
  volleyball: "VolleyballTeamDashboard",
});

/** Canonical paths for team registration (post-login redirects, deep links). */
export const SPORT_REGISTER_PATHS = Object.freeze({
  football: "/ipromiseafrica/matchup/football/register",
  basketball: "/ipromiseafrica/matchup/basketball/register",
  rugby: "/ipromiseafrica/matchup/rugby/register",
  tennis: "/ipromiseafrica/matchup/tennis/register",
  volleyball: "/ipromiseafrica/matchup/volleyball/register",
});

/** Canonical paths for team owner dashboards. */
export const SPORT_DASHBOARD_PATHS = Object.freeze({
  football: "/ipromiseafrica/matchup/football/dashboard",
  basketball: "/ipromiseafrica/matchup/basketball/dashboard",
  rugby: "/ipromiseafrica/matchup/rugby/dashboard",
  tennis: "/ipromiseafrica/matchup/tennis/dashboard",
  volleyball: "/ipromiseafrica/matchup/volleyball/dashboard",
});

/** Vue Router route names for sport-specific organize / discover pages. */
export const SPORT_ORGANIZE_MATCH_ROUTES = Object.freeze({
  football: "FootballOrganizeMatch",
  basketball: "BasketballOrganizeMatch",
  rugby: "RugbyOrganizeMatch",
  tennis: "TennisOrganizeMatch",
  volleyball: "VolleyballOrganizeMatch",
});

/** Canonical paths for discover & organize match flows. */
export const SPORT_ORGANIZE_MATCH_PATHS = Object.freeze({
  football: "/ipromiseafrica/matchup/football/organize-match",
  basketball: "/ipromiseafrica/matchup/basketball/organize-match",
  rugby: "/ipromiseafrica/matchup/rugby/organize-match",
  tennis: "/ipromiseafrica/matchup/tennis/organize-match",
  volleyball: "/ipromiseafrica/matchup/volleyball/organize-match",
});

/** Sport-specific discover (organize match) API paths. */
export const SPORT_DISCOVER_API = Object.freeze({
  football: "/api/teams/discover",
  basketball: "/api/teams/basketball/discover",
  rugby: "/api/teams/rugby/discover",
  tennis: "/api/teams/tennis/discover",
  volleyball: "/api/teams/volleyball/discover",
});

/** Sport-specific match-hub status API paths (owner team gate). */
export const SPORT_MATCH_HUB_STATUS_API = Object.freeze({
  football: "/api/teams/match-hub-status",
  basketball: "/api/teams/basketball/match-hub-status",
  rugby: "/api/teams/rugby/match-hub-status",
  tennis: "/api/teams/tennis/match-hub-status",
  volleyball: "/api/teams/volleyball/match-hub-status",
});

/** Human-readable route descriptions (meta, sitemap, docs). */
export const SPORT_REGISTRATION_META = Object.freeze({
  football: {
    title: "Register football team",
    description:
      "Create an 11-a-side football squad on ToAfrica Match Hub — home ground, roster, fixtures, and challenges.",
  },
  basketball: {
    title: "Register basketball team",
    description:
      "Create a basketball crew on ToAfrica Match Hub — 5v5 or 3v3, court preferences, roster size, and game format.",
  },
  rugby: {
    title: "Register rugby team",
    description:
      "Create a rugby club on ToAfrica Match Hub — XV, 7s, or 10s, home pitch, roster size, and match preferences.",
  },
  tennis: {
    title: "Register tennis team",
    description:
      "Create a tennis team on IpromiseAfrica Match Hub — singles or doubles format, venue preferences, and player availability.",
  },
  volleyball: {
    title: "Register volleyball team",
    description:
      "Create a volleyball squad on ToAfrica Match Hub — 6v6 or beach, venue preferences, roster size, and match format.",
  },
});
